import { useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody } from 'reactstrap';
import { HubspotBrochureDownload  } from '.'

const StartTrialModal = (props) => {
    const {
        buttonLabel,
        className
    } = props;

    const [modal, setModal] = useState(false);

    const toggle = () => setModal(!modal);

    return (
        <>
            <Button className="button-style banner_btn" onClick={toggle}>Start Free Trial</Button>
            <Modal isOpen={modal} toggle={toggle} className={className}>
                <ModalHeader toggle={toggle}>Sign Up For Your Free Trial</ModalHeader>
                <ModalBody>
                        <HubspotBrochureDownload formID="26a70293-9f2c-4790-8d1a-e51244ac169f"/>
                        <p className="smallfont text-center">
                        We safeguard your personal information in accordance with our <a href="https://api.vantagecircle.com/vantagefit/api/v1/tnc/355?isPrivacy=true" className="companycolor">Privacy Policy</a>
                    </p>

                </ModalBody>     
            </Modal>
        </>
    );
}

export default StartTrialModal;